import { OrderProp } from "@/interface/account";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import toast from "react-hot-toast";


type OrderProps = {
	address: string;
	createdAt: string; 
	delivery_date: string; 
	delivery_fee: number;
	delivery_time: {
	  dateString: string;
	  timeRange: string;
	};
	description: string | null;
	email: string;
	gift_receiver_name: string | null;
	gift_receiver_phone: string | null;
	gift_sender_name: string | null;
	gift_sender_phone: string | null;
	id: string;
	isGift: boolean;
	landmark: string | null;
	orderId: string;
	phone: string;
	product_for_vendor: string | null;
	receiver_name: string;
	status: string;
	user: string | null;
	activeOrder: object | OrderProp
  };
  


	const initialState: OrderProps = {
		address: "",
		createdAt: "",
		delivery_date: "",
		delivery_fee: 0,
		delivery_time: {
		  dateString: "",
		  timeRange: "",
		},
		description: null,
		email: "",
		gift_receiver_name: null,
		gift_receiver_phone: null,
		gift_sender_name: null,
		gift_sender_phone: null,
		id: "",
		isGift: false,
		landmark: null,
		orderId: "",
		phone: "",
		product_for_vendor: null,
		receiver_name: "",
		status: "",
		user: null,
		activeOrder: {},
	  };
	

const orderSlice = createSlice({
	name: "order",
	initialState,
	reducers: {
		updateOrder: (state, action: PayloadAction<OrderProps>) => {
			return { ...state, ...action.payload };
		},
		updateActiveOrder: (state, action: PayloadAction<OrderProp>) => {
            return{
				...state,
				activeOrder: action.payload,
			}
		},
		resetOrder: (state) => {
			return {
				...state,
				address: "",
		createdAt: "",
		delivery_date: "",
		delivery_fee: 0,
		delivery_time: {
		  dateString: "",
		  timeRange: "",
		},
		description: null,
		email: "",
		gift_receiver_name: null,
		gift_receiver_phone: null,
		gift_sender_name: null,
		gift_sender_phone: null,
		id: "",
		isGift: false,
		landmark: null,
		orderId: "",
		phone: "",
		product_for_vendor: null,
		receiver_name: "",
		status: "",
		user: null,
			}
		},
		
	},
});

export default orderSlice.reducer;
export const {
	updateOrder,
	resetOrder,
	updateActiveOrder
	
} = orderSlice.actions;
